<template>
  <generic-error>
    <template v-slot:title>Erreur de paramétrage du formulaire</template>
    <h1>Oh oh ! 🙁</h1>
    <p>Aucun paramétrage n'a été trouvé pour ce formulaire: <pre>{{ id }}</pre></p>
  </generic-error>
</template>

<script>
import GenericError from "./GenericError"
export default {
  props: {
    id: { type: String }
  },
  components: {
    GenericError
  }
}
</script>

<style scoped>
pre {
  display: inline;
  padding: 5px;
  background: rgb(233, 231, 231);
  border-radius: 4px;
}
</style>
